import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { AdminConfig } from "../features/core/models/AdminConfig";

export interface AdminConfigState {
  timeoutInSeconds: number;
}

const initialState: AdminConfigState = {
  timeoutInSeconds: 7200
};

export const AdminConfigSlice = createSlice({
  name: "adminConfigSlice",
  initialState,
  reducers: {
    setAdminConfig: (state, action: PayloadAction<AdminConfig>) => {
      return {
        timeoutInSeconds: action.payload.timeoutInSeconds
      };
    },
  }
});

export const {
  setAdminConfig,
} = AdminConfigSlice.actions;
